@use '@design/design-tokens/typography/typography' as *;

.uploadDisclaimer {
  height: 16px;
  margin-top: 8px;
  text-align: center;
  @include typography-v2-body-xs;
}

.styledAnchor {
  @include typography-v2-body-xs;
  color: var(--surface-primary);
  text-decoration: none;

  &:hover {
    color: var(--surface-primary);
    text-decoration: underline;
  }
}
